import links from 'common/helpers/links'
import object from 'common/helpers/primitives/object'
import cosmeticsProductTypes from './cosmeticsProductTypes'


// Product type values from scentbird-domain/grails-app/domain/com/scentbird/products/ProductInfoType.groovy
const makeupValues = {
  eye: {
    'eyeliner': cosmeticsProductTypes.makeup.eye.eyeLiner,
    'eye pencil': cosmeticsProductTypes.makeup.eye.eyePencil,
    'mascara': cosmeticsProductTypes.makeup.eye.eyeMascara,
    'eyebrow': cosmeticsProductTypes.makeup.eye.eyebrow,
    'eye treatment': cosmeticsProductTypes.makeup.eye.eyeTreatment,
    'tattoo liner': cosmeticsProductTypes.makeup.eye.tattooLiner,
    'liquid liner': cosmeticsProductTypes.makeup.eye.liquidLiner,
  },
  lip: {
    'lip color': cosmeticsProductTypes.makeup.lip.lipColor,
    'lip color pencil': cosmeticsProductTypes.makeup.lip.lipColorPencil,
    'lip crayon': cosmeticsProductTypes.makeup.lip.lipCrayon,
    'lip liner': cosmeticsProductTypes.makeup.lip.lipLiner,
    'lip paint': cosmeticsProductTypes.makeup.lip.lipPaint,
    'lipstick': cosmeticsProductTypes.makeup.lip.lipstick,
  },
}

const productTypeLinks = [
  {
    baseUrl: links.handCreams,
    values: 'hand cream',
  },
  {
    baseUrl: links.bodyLip,
    values: 'lip balm',
  },

  {
    baseUrl: links.candles,
    values: 'scent candle',
  },
  {
    baseUrl: typeof links.subscription === 'string' ? null : links.subscription.extras,
    values: [ 'candle set', 'perfume case', 'fragrance storage box' ],
  },

  {
    baseUrl: links.makeupEye,
    values: Object.keys(makeupValues.eye),
    queryTypes: makeupValues.eye,
  },
  {
    baseUrl: links.makeupLip,
    values: Object.keys(makeupValues.lip),
    queryTypes: makeupValues.lip,
  },
  {
    baseUrl: links.makeupPalettes,
    values: 'palette',
  },

  {
    baseUrl: typeof links.subscription === 'string' ? null : links.subscription.perfumes,
    baseMenUrl: typeof links.subscription === 'string' ? null : links.subscription.colognes,
    values: [ 'eau de toilette', 'eau de cologne', 'eau de parfum', 'parfum oil', 'blended essence', 'extrait de parfum' ],
  },

  {
    baseUrl: links.giftSet,
    values: 'gift set',
  },
]


export default productTypeLinks
